import useCurrentUser from "data/advisor/useCurrentUser";
import useHub from "data/hub/useHub";

function useConnectionType() {
  const user = useCurrentUser();
  const hub = useHub();

  return {
    isCrmReset: Boolean(
      !user?.connectCrm &&
        hub?.clientPool?.type &&
        hub?.clientPool?.type !== "hubly"
    ),
    isFirstCrmConnection: !hub?.clientPool?.type,
    isRequiredCrmConnection: Boolean(user?.connectCrm && hub?.clientPool?.type),
  };
}

export default useConnectionType;
